import React from 'react';
import DepartmentPaymentRequests from '../../components/DepartmentPaymentRequests';

const HRPaymentRequests = () => {
  return <DepartmentPaymentRequests department="HR" departmentLabel="HR Dept" />;
};

export default HRPaymentRequests;
